import { BookingStepper } from '@/components/BookingStepper';
import { ContentContainer } from '@/components/ContentContainer';
import { Header } from '@/components/Header';
import { useBookSkiPassStore } from '@/store/book-ski-pass.store';
import type { Step } from '@/types/types';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styles from './BookingFlowLayout.module.css';

const PATH_STEP: Record<string, Step> = {
  '/trip-details': 1,
  '/ski-pass-offers': 2,
  '/booking-details': 3,
  '/payment': 4,
};

const STEP_PATH: Partial<Record<Step, string>> = {
  1: '/trip-details',
  2: '/ski-pass-offers',
  3: '/booking-details',
  4: '/payment',
};

export const BookingFlowLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentStep = useBookSkiPassStore((state) => state.currentStep);
  const setCurrentStep = useBookSkiPassStore((state) => state.setCurrentStep);

  const searchParams = new URLSearchParams(location.search);
  const isPaymentSuccessReturn =
    location.pathname === '/payment' && Boolean(searchParams.get('session_id'));

  const stepFromPath = PATH_STEP[location.pathname];

  useEffect(() => {
    if (stepFromPath != null && currentStep !== stepFromPath) {
      setCurrentStep(stepFromPath);
    }
  }, [stepFromPath, currentStep, setCurrentStep]);

  const activeStep = stepFromPath ?? currentStep;

  const handleStepClick = (step: Step) => {
    const path = STEP_PATH[step];
    if (path != null) void navigate(path);
  };

  return (
    <main className="app">
      <Header />
      <ContentContainer
        className={`${styles.contentContainer} ${isPaymentSuccessReturn ? styles.successContentContainer : ''}`}
      >
        {!isPaymentSuccessReturn && (
          <BookingStepper currentStep={activeStep} onStepClick={handleStepClick} />
        )}
        <Outlet />
      </ContentContainer>
    </main>
  );
};
